"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _formWrapper = require("../../../../reducers/formWrapper.js");
var _availableAssignmentPlans = _interopRequireDefault(require("./availableAssignmentPlans.graphql"));
var _visibleRolesForGroup = _interopRequireDefault(require("./visibleRolesForGroup.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AssignmentPlanSelections = function AssignmentPlanSelections(props) {
  var displaySettings = props.displaySettings,
    _props$field = props.field,
    error = _props$field.error,
    touched = _props$field.touched,
    operation = props.operation,
    reduxForm = props.reduxForm,
    row = props.row,
    validationSettings = props.validationSettings;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selections = _useState2[0],
    setSelections = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    allAvailablePlans = _useState6[0],
    setAllAvailablePlans = _useState6[1];
  var groupType = (0, _get2["default"])(reduxForm, "DynamicForm.".concat(displaySettings.groupTypeReduxHandle || 'type', ".value"), '');
  var visibleRoles = (0, _visibleRolesForGroup["default"])(groupType);
  var allAvailablePlanRoles = allAvailablePlans.map(function (p) {
    return p.role;
  });
  var eligibleRoles = visibleRoles.filter(function (r) {
    return allAvailablePlanRoles.includes(r.handle);
  });
  if (displaySettings.roleWhitelist) {
    eligibleRoles = eligibleRoles.filter(function (r) {
      return displaySettings.roleWhitelist.includes(r.handle);
    });
  }
  var parentGroup = displaySettings.parentGroupReduxHandle && (0, _get2["default"])(reduxForm, "DynamicForm.".concat(displaySettings.parentGroupReduxHandle), null) || null;
  var parentGroupId = parentGroup ? parentGroup.value : null;

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    function getPlanData() {
      return _getPlanData.apply(this, arguments);
    }
    function _getPlanData() {
      _getPlanData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var groupIdPath, groupId, result, resultParentAvailablePlans, resultParentCreatedPlans, resultCreatedPlans, combinedResultPlans, resultSelectedPlans, allAvailablePlanIds;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              groupIdPath = displaySettings.groupIdPath || 'group.groupId';
              groupId = row && row[groupIdPath] || 0;
              if (!(operation === 'create')) {
                _context.n = 1;
                break;
              }
              if (parentGroupId) {
                _context.n = 1;
                break;
              }
              setLoading(false);
              return _context.a(2);
            case 1:
              _context.n = 2;
              return _cccisdApollo.client.query({
                query: _availableAssignmentPlans["default"],
                variables: {
                  groupId: groupId,
                  parentGroupId: parentGroupId || 0
                },
                fetchPolicy: 'network-only'
              });
            case 2:
              result = _context.v;
              resultParentAvailablePlans = (0, _get2["default"])(result, 'data.groups.parentGroupPlans.availableAssignmentPlanList', []);
              resultParentCreatedPlans = (0, _get2["default"])(result, 'data.groups.parentGroupPlans.createdAssignmentPlanList', []);
              resultCreatedPlans = (0, _get2["default"])(result, 'data.groups.anyGroup.createdAssignmentPlanList', []);
              combinedResultPlans = [].concat(_toConsumableArray((0, _cloneDeep2["default"])(resultCreatedPlans)), _toConsumableArray((0, _cloneDeep2["default"])(resultParentCreatedPlans)), _toConsumableArray((0, _cloneDeep2["default"])(resultParentAvailablePlans)));
              setAllAvailablePlans((0, _uniqBy2["default"])(combinedResultPlans, 'planId'));
              resultSelectedPlans = (0, _get2["default"])(result, 'data.groups.anyGroup.selectedAssignmentPlanList', []);
              if (loading) {
                updateSelections(resultSelectedPlans.map(function (p) {
                  return {
                    role: p.role,
                    planId: p.planId
                  };
                }));
              } else {
                allAvailablePlanIds = combinedResultPlans.map(function (p) {
                  return p.planId;
                });
                updateSelections(resultSelectedPlans.map(function (p) {
                  return {
                    role: p.role,
                    planId: allAvailablePlanIds.includes(p.planId) ? p.planId : null
                  };
                }));
              }
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _getPlanData.apply(this, arguments);
    }
    getPlanData();
  }, [parentGroupId]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function updateSelections(updatedSelections) {
    props.changeAllFields(updatedSelections, props);
    setSelections(updatedSelections);
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var renderPlanSelections = eligibleRoles.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", null, "No data available.") : /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formField
  }, eligibleRoles.map(function (g) {
    var hasError = error && error[g.handle];
    var currentSelection = selections.find(function (s) {
      return s.role === g.handle;
    }) || null;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: g.handle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formField
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, g.label, ":"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: [{
        label: displaySettings.placeholder || displaySettings.placeholder === '' ? displaySettings.placeholder : '--- Choose a Plan ---',
        planId: null,
        role: g.handle
      }].concat(_toConsumableArray(allAvailablePlans.filter(function (p) {
        return p.role === g.handle;
      }))),
      itemComponent: function itemComponent(_ref) {
        var item = _ref.item;
        return item.label;
      },
      onChange: function onChange(p) {
        updateSelections([].concat(_toConsumableArray(selections.filter(function (s) {
          return s.role !== p.role;
        })), [{
          role: p.role,
          planId: p.planId
        }]));
      },
      value: currentSelection,
      valueComponent: function valueComponent(_ref2) {
        var item = _ref2.item;
        return item && item.label || null;
      },
      valueField: "planId",
      containerClassName: (0, _classnames["default"])(hasError && 'is-invalid')
    }), !!hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "invalid-feedback"
    }, hasError)));
  }));
  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var hasGeneralError = !!(touched && error && typeof error === 'string');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_style["default"].formField, hasGeneralError && 'is-invalid')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('form-label', validationSettings.isRequired && _style["default"].required)
  }, "Assignment Plan Selection:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].selectorContainer
  }, renderPlanSelections), !!hasGeneralError && /*#__PURE__*/_react["default"].createElement("div", {
    className: "invalid-feedback"
  }, error));
};
AssignmentPlanSelections.propTypes = {
  /**
   * Callback to change the redux value of the field AND all fields that
   * depend on it
   */
  changeAllFields: _propTypes["default"].func,
  displaySettings: _propTypes["default"].object,
  /** The redux form fields object */
  field: _propTypes["default"].object.isRequired,
  /** Each appdef field, keyed by handle (needed for changeAllFields) */
  fieldTypes: _propTypes["default"].object,
  /** GraphQL appdef settings */
  graphqlSettings: _propTypes["default"].object,
  isDisabled: _propTypes["default"].bool,
  /** All data loaded from graphql */
  loadedData: _propTypes["default"].object,
  /** 'create' or 'edit' */
  operation: _propTypes["default"].string,
  /** The reduxForm, from mapStateToProps */
  reduxForm: _propTypes["default"].object,
  /**
   * Array of field handles which should be set to the same value as this
   * field, keyed by handles (needed for changeAllFields)
   */
  requiredByFields: _propTypes["default"].object,
  row: _propTypes["default"].object,
  validationSettings: _propTypes["default"].object
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(AssignmentPlanSelections);